import { Component, OnInit } from '@angular/core';
import { PreAuthenticationResponse } from '@picard/models-lib';
import { BreadcrumbService, ApplicationService } from '@picard/services-lib';
import { Title } from '@angular/platform-browser';
import { StorageConstants } from '@picard/shared-lib';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent implements OnInit {
  //#region Properties
  preAuthenticationResponse: PreAuthenticationResponse;
  docTheme = document.getElementById('theme-css');
  docLayout = document.getElementById('layout-css');
  //#endregion Properties

  //#region Constructor
  constructor(private _breadcrumbService: BreadcrumbService, private _title: Title, private _applicationService: ApplicationService) {
    this._breadcrumbService.setItems([{ label: 'Terms and Conditions', routerLink: '/terms' }, { label: 'Privacy', routerLink: '/privacy' }]);

    if (this.docTheme) {
      this.docTheme.setAttribute('href', this._applicationService.preAuthenticationResponse.programmeAssetsModel.theme);
    }
    if (this.docLayout) {
      this.docLayout.setAttribute('href', this._applicationService.preAuthenticationResponse.programmeAssetsModel.layout);
    }
  }
  //#endregion Constructor

  //#region Functions
  ngOnInit() {
    this.preAuthenticationResponse = JSON.parse(sessionStorage.getItem(StorageConstants.preAuth));
    this._title.setTitle(`${this.preAuthenticationResponse.description} - Privacy`);
  }
  //#endregion Functions
}
